import React from "react";
import CampoComboFuenteInformacion from "../../UI/campos/CampoComboFuenteInformacion.js";
import CampoComboParametro from "../../UI/campos/CampoComboParametro.js";
import CampoEditableFechaCampos from "../../UI/campos/CampoEditableFechaCampos.js";
import CampoEditableTexto from "../../UI/campos/CampoEditableTexto.js";
import CampoEditableMultilinea from "../../UI/campos/CampoEditableMultilinea.js";
import * as Campos from "../../constantes/Campos.js";
import * as TipoParametro from "../../constantes/TipoParametro.js";
import LargoCampos from "../../largoCampos/LargoCampos.js";
import styles from "../EditarItemLista.module.css";
import CampoEditableNumero from "../../UI/campos/CampoEditableNumero.js";

const CamposInformaciones = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Tipo</td>
        <td className={`${styles.valor}`}>
          <CampoComboParametro
            nombre={Campos.Informacion.TIPO_INFORMACION}
            tipoParametro={TipoParametro.TIPO_INFORMACION}
            estilo={`${styles.comboDatos}`}
            valor={item && item.tipoInformacion}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fuente</td>
        <td className={`${styles.valor}`}>
          <CampoComboFuenteInformacion
            nombre={Campos.Informacion.FUENTE_INFORMACION}
            estilo={`${styles.comboDatos}`}
            valor={item && item.fuenteInformacion}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Número Fuente</td>
        <td className={`${styles.valor}`}>
          <CampoEditableNumero
            nombre={Campos.Informacion.NUMERO_FUENTE}
            valor={item && item.numeroFuente}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Fecha Fuente</td>
        <td className={`${styles.valor}`}>
          <CampoEditableFechaCampos
            nombre={Campos.Informacion.FECHA_FUENTE}
            anio={item && item.anioFuente}
            mes={item && item.mesFuente}
            dia={item && item.diaFuente}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Detalle Fuente</td>
        <td className={`${styles.valor}`}>
          <CampoEditableTexto
            nombre={Campos.Informacion.DETALLE_FUENTE}
            largo={100}
            valor={item && item.detalle}
            editar={editar}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Observaciones</td>
        <td className={`${styles.valor}`}>
          <CampoEditableMultilinea
            filas="3"
            columnas="46"
            nombre={Campos.NombreEstadio.OBSERVACIONES}
            valor={item && item.observaciones}
            largo={LargoCampos.OBSERVACIONES}
            editar={editar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposInformaciones;
